import React from 'react';

export const YelpLogoWhite = ({ className = 'w-[51px] h-[20px]' }: { className?: string }) => {
  return <img src={'/yelp-white.svg'} alt="yelp logo" className={className} />;
};
